import { css } from 'aphrodite';
import { IUser } from '../../../extViewmodels';
import { TITLE_SEARCH_MAX_RANGE_DAYS } from '../../../queries/AIConversation/useSalesLiveCoachingConversationsQuery';
import { ComboboxContent, ComboboxInput, ComboboxList } from '../../../web/components-v2/Combobox';
import { DateInput } from '../../../web/components-v2/DateInput';
import { Input } from '../../../web/components-v2/Input';
import { UserCombobox, UserComboboxAvatarItem, UserComboboxStatus } from '../../../web/components/UserCombobox';
import { styleSheet } from './styles';

interface IProps {
	search: string;
	onSearchChange: (value: string) => void;
	/** Server-side title search needs a valid ≤30-day range (it 400s otherwise), so it's gated. */
	titleSearchEnabled: boolean;
	/** Selected rep user id, or '' for all reps. */
	creatorId: string;
	onCreatorChange: (value: string) => void;
	startDate: string;
	onStartDateChange: (value: string) => void;
	endDate: string;
	onEndDateChange: (value: string) => void;
}

/** Presentational filter bar (title search / rep typeahead / date range); the parent owns the state. */
export function ListFilters({
	search,
	onSearchChange,
	titleSearchEnabled,
	creatorId,
	onCreatorChange,
	startDate,
	onStartDateChange,
	endDate,
	onEndDateChange,
}: IProps) {
	return (
		<div className={css(styleSheet.filters)}>
			<Input
				value={search}
				onChange={e => onSearchChange(e.target.value)}
				disabled={!titleSearchEnabled}
				placeholder={titleSearchEnabled ? 'Search by title' : 'Pick a date range to search titles'}
				aria-label='Search by title'
				title={
					titleSearchEnabled
						? 'Matches saved conversation titles'
						: `Title search needs a date range of ${TITLE_SEARCH_MAX_RANGE_DAYS} days or fewer`
				}
			/>
			<UserCombobox
				id={creatorId || undefined}
				key={`rep-${creatorId}`}
				onValueChange={(user: IUser | null) => onCreatorChange(user?.id ?? '')}
			>
				<ComboboxInput
					placeholder='Filter by rep'
					aria-label='Filter by rep'
					showClear
					styles={[styleSheet.repSelectTrigger]}
				/>
				<ComboboxContent>
					<UserComboboxStatus />
					<ComboboxList>
						{(user: IUser) => <UserComboboxAvatarItem key={`rep-item-${user.id}`} user={user} />}
					</ComboboxList>
				</ComboboxContent>
			</UserCombobox>
			<div className={css(styleSheet.filterDateRange)}>
				<DateInput value={startDate} onChange={onStartDateChange} />
				<DateInput value={endDate} onChange={onEndDateChange} />
			</div>
		</div>
	);
}
